import type { ToolId } from "@/types/settings";

// Stable UUIDs seeded in tool migrations (initial + subsequent builtin additions).
// a2 (OpenAI Web Search) and a4 (OpenAI Code Interpreter) were removed in
// 20260430000004 — their functionality lives inside a1 and a3 via the
// executor_config.providers map.
export const BUILTIN_TOOL_UUID: Record<ToolId, string> = {
  webSearch:           "a1000000-0000-0000-0000-000000000001",
  codeExecution:       "a3000000-0000-0000-0000-000000000003",
  memory:              "a6000000-0000-0000-0000-000000000006",
  knowledgeBase:       "a7000000-0000-0000-0000-000000000007",
  webFetch:            "a8000000-0000-0000-0000-000000000008",
  resolveDateTime:     "b1000000-0000-0000-0000-000000000001",
  woodsIdentity:       "b0000000-0000-0000-0000-000000000001",
  searchProjectChats:              "b2000000-0000-0000-0000-000000000002",
  searchProjectMeetingMinutes:     "b3000000-0000-0000-0000-000000000003",
  projectRegisters:      "b4000000-0000-0000-0000-000000000004",
  writingStyleProfile: "a9000000-0000-0000-0000-000000000009",
  myFiles:             "b5000000-0000-0000-0000-000000000005",
};

export const BUILTIN_UUID_TO_TOOL_ID: Record<string, ToolId> = Object.fromEntries(
  Object.entries(BUILTIN_TOOL_UUID).map(([toolId, uuid]) => [uuid, toolId as ToolId])
);

export const KB_BUILTIN_TOOL_UUID = BUILTIN_TOOL_UUID.knowledgeBase;
export const WEB_SEARCH_BUILTIN_TOOL_UUID = BUILTIN_TOOL_UUID.webSearch;
export const RESOLVE_DATE_TIME_BUILTIN_TOOL_UUID = BUILTIN_TOOL_UUID.resolveDateTime;
